import { createAction, props } from '@ngrx/store';

import { Product } from '../../../objects/product';
import { DateOfStay } from '../../../objects/date-of-stay';
import { LayoutPosition } from '../../../objects/layout-unit-position';
import { Layout } from '../../../objects/layout';
import { MappedArea } from 'src/objects/mapped-area';
import { InventoryUnit } from 'src/objects/inventory-unit';
import { Landmark } from 'src/objects/layout-landmark';
import { TemplatedLayoutPosition } from 'src/objects/layout-position';
import { Section } from '../../../objects/section';
import { Destination } from 'src/objects/destination';
import { Order } from 'src/objects/order';

export const loadTemplatedLayoutPositionsWithInventoryUnits = createAction(
  '[Layout] Load Templated Layout Positions',
  props<{ mappedArea: MappedArea; dateOfStay: DateOfStay }>(),
);

export const loadTemplatedLayoutPositionsWithInventoryUnitsSuccess = createAction(
  '[Layout] Load Templated Layout Positions Success',
  props<{positions: TemplatedLayoutPosition[]; inventoryUnits: InventoryUnit[]; products: Product[]; sections: Section[]}>(),
);

export const loadTemplatedLayoutPositionsWithInventoryUnitsFailure = createAction(
  '[Layout] Load Templated Layout Positions Error',
  props<{error: Error}>(),
);

export const loadTemplatedLayoutLandmarks = createAction(
  '[Layout] Load Templated Layout Landmarks',
  props<{ mappedArea: MappedArea; dateOfStay: DateOfStay }>(),
);

export const loadTemplatedLayoutLandmarksSuccess = createAction(
  '[Layout] Load Templated Layout Landmarks Success',
  props<{layoutLandmarks: Landmark[]}>(),
);

export const loadTemplatedLayoutLandmarksFailure = createAction(
  '[Layout] Load Templated Layout Landmarks Error',
  props<{error: Error}>(),
);

export const selectLayoutUnitPositions = createAction(
  '[Layout] Select Layout Unit Positions',
  props<{
    layoutUnitPositions: LayoutPosition[],
    product: Product,
    destination: Destination,
    dateOfStay: DateOfStay,
    order: Order,
  }>(),
);

export const selectLayout = createAction(
  '[Layout] Select Layout',
  props<{layout: Layout}>(),
);
